"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isConnectivityIssue = function (error) {
    var httpEndpointNotAvailableError = error.message === 'Network Error' || error.message === 'Cannot send request because there is no http client';
    var webSocketConnectionNotOpenError = error.message === 'Cannot send request because there is no websocket client' ||
        error.message === 'Cannot send request because websocket connection is closed';
    return httpEndpointNotAvailableError || webSocketConnectionNotOpenError;
};
var CLIPBOARD_HANDSHAKE_ERROR_MESSAGE = 'Call to the original function failed because clipboard handshake failed';
var isClipboardHandshakeError = function (error) {
    return error.message === CLIPBOARD_HANDSHAKE_ERROR_MESSAGE;
};
function retryOnceAfterConnectivityIssue(originalAsyncFn, config) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var originalResponse, error_1, reconnectPromise, originalResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 7]);
                    return [4, originalAsyncFn()];
                case 1:
                    originalResponse = _a.sent();
                    return [2, originalResponse];
                case 2:
                    error_1 = _a.sent();
                    if (!(isConnectivityIssue(error_1) || isClipboardHandshakeError(error_1))) return [3, 5];
                    reconnectPromise = config.getConnectionChannel().connect({ handshakeMethods: ['COOKIE'] });
                    if (!!config.companionClientEventHandler) {
                        config.companionClientEventHandler({ event: 'RECONNECTING', callerFunctionName: config.functionName, data: reconnectPromise });
                    }
                    return [4, reconnectPromise];
                case 3:
                    _a.sent();
                    return [4, originalAsyncFn()];
                case 4:
                    originalResponse = _a.sent();
                    return [2, originalResponse];
                case 5: throw error_1;
                case 6: return [3, 7];
                case 7: return [2];
            }
        });
    }); };
}
exports.retryOnceAfterConnectivityIssue = retryOnceAfterConnectivityIssue;
exports.emitMetricsAndLogs = function (originalAsyncFn, config) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var successLatencyHandler, failLatencyHandler, originalResponse, error_2;
        var _a, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    successLatencyHandler = config.metricService.newLatencyMetric(((_a = config.connectionChannel) === null || _a === void 0 ? void 0 : _a.clientType) + "." + config.functionName + ".Success");
                    failLatencyHandler = config.metricService.newLatencyMetric(((_b = config.connectionChannel) === null || _b === void 0 ? void 0 : _b.clientType) + "." + config.functionName + ".Fail");
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, originalAsyncFn()];
                case 2:
                    originalResponse = _c.sent();
                    successLatencyHandler.stopAndEmitMetric();
                    return [2, originalResponse];
                case 3:
                    error_2 = _c.sent();
                    failLatencyHandler.stopAndEmitMetric();
                    config.logger.log({
                        Event: 'COMPANION_CALL_FAILED',
                        ApiOperationName: config.functionName,
                        ErrorMessage: error_2.message,
                        ErrorStack: error_2.stack,
                    });
                    throw error_2;
                case 4: return [2];
            }
        });
    }); };
};
function awaitUntilConnectionChannelSet(originalAsyncFn, config) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!!config.companionClient.connectionChannelSettingPromise) return [3, 2];
                    return [4, config.companionClient.connectionChannelSettingPromise];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [4, originalAsyncFn()];
                case 3: return [2, _a.sent()];
            }
        });
    }); };
}
exports.awaitUntilConnectionChannelSet = awaitUntilConnectionChannelSet;
function connectUsingClipboardHandshake(originalAsyncFn, config) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var error_3;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!config.getConnectionChannel().getLastSucceededHandshakeMethod()) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, config.getConnectionChannel().connect({ handshakeMethods: ['CLIPBOARD'] })];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    error_3 = _a.sent();
                    throw Error(CLIPBOARD_HANDSHAKE_ERROR_MESSAGE);
                case 4: return [4, originalAsyncFn()];
                case 5: return [2, _a.sent()];
            }
        });
    }); };
}
exports.connectUsingClipboardHandshake = connectUsingClipboardHandshake;
function retrySettingConnectionChannel(originalAsyncFn, config) {
    var _this = this;
    return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var promise;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!config.companionClient.connectionChannelSettingPromise && !config.companionClient.connectionChannel) {
                        promise = config.setConnectionChannel(['CLIPBOARD', 'QUICK', 'COOKIE']);
                        config.companionClient.connectionChannelSettingPromise = promise;
                        config.companionClient.connectionChannelSettingPromise.then(function () {
                            config.companionClient.connectionChannelSettingPromise = null;
                        }, function () {
                            config.companionClient.connectionChannelSettingPromise = null;
                        });
                        if (!!config.companionClientEventHandler) {
                            config.companionClientEventHandler({ event: 'RECONNECTING', data: promise });
                        }
                    }
                    return [4, originalAsyncFn()];
                case 1: return [2, _a.sent()];
            }
        });
    }); };
}
exports.retrySettingConnectionChannel = retrySettingConnectionChannel;
